import { getToken, onMessage } from 'firebase/messaging';
import { isSupported, getMessaging, app } from '../lib/firebase';
import { account, ID } from '../lib/appwrite';

const PROVIDER_ID = '6a25cb720026cb0e260a';
const TARGET_KEY = 'fcm_target_id';
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const NotificationService = {
  async init() {
    try {
      const supported = await isSupported();
      if (!supported) return;

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return;

      const messaging = getMessaging(app);
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (token) await this._sync(token);

      onMessage(messaging, (payload) => {
        const { title, body } = payload.notification ?? {};
        if (title && Notification.permission === 'granted') {
          new Notification(title, { body, icon: '/logo192.png' });
        }
      });
    } catch (err) {
      console.warn('[FCM] init failed:', err.message);
    }
  },

  async _sync(token) {
    try {
      const existingTargetId = localStorage.getItem(TARGET_KEY);
      if (existingTargetId) {
        // Already registered in a previous session — updating is the only
        // call that can succeed, so don't waste a request on create-then-409.
        await account.updatePushTarget(existingTargetId, token);
        return;
      }

      const targetId = ID.unique();
      await account.createPushTarget(targetId, token, PROVIDER_ID);
      localStorage.setItem(TARGET_KEY, targetId);
    } catch (err) {
      console.warn('[FCM] token sync failed:', err.message);
    }
  },
};

export default NotificationService;
